module.exports = __webpack_public_path__ + "media/src/images/buttons/hamburger-b18eadddea1de90c841fdfa58641c1c0.svg";